module.exports = __webpack_public_path__ + "img/section1img_ar.cde83510.jpg";